import type {
  IOpportunity,
  IOpportunityLastSelectedState,
  IOpportunityOverview,
  IOpportunityParentObjectForCreate,
} from '../opportunity/models'
import type {
  IOrder,
  IOrderLastSelectedState,
  IOrderOverview,
  IOrderParentObjectForCreate,
} from '../order/models'
import type {
  ICompany,
  ICompanyLastSelectedState,
  ICompanyOverview,
  ICompanyParentObjectForCreate,
} from '../company/models'
import { isOpportunity } from '../opportunity/models'
import { isOrder } from '../order/models'
import { isCompany } from '../company/models'

export type TSiloRoot = IOpportunity | IOrder | ICompany

export function assertIsTSiloRoot(
  fn: string,
  val: any
): asserts val is TSiloRoot {
  if (!isOpportunity(val) && !isOrder(val) && !isCompany(val)) {
    throw new Error(
      `${fn} val should be an IOpportunity, IOrder, or ICompany, but it's not.`
    )
  }
}

export type TSiloOverview =
  | IOpportunityOverview
  | IOrderOverview
  | ICompanyOverview

export type TRootEntityLastSelectedState =
  | IOpportunityLastSelectedState
  | IOrderLastSelectedState
  | ICompanyLastSelectedState

export type TRootEntityParentObjectForCreate =
  | IOpportunityParentObjectForCreate
  | IOrderParentObjectForCreate
  | ICompanyParentObjectForCreate

export function isIOpportunityOverviewData(
  overviewData: TSiloOverview
): overviewData is IOpportunityOverview {
  return (overviewData as IOpportunityOverview).hasOwnProperty('opportunity')
}

export function isIOrderOverviewData(
  overviewData: TSiloOverview
): overviewData is IOrderOverview {
  return (overviewData as IOrderOverview).hasOwnProperty('order')
}

export function isICompanyOverviewData(
  overviewData: TSiloOverview
): overviewData is ICompanyOverview {
  return (overviewData as ICompanyOverview).hasOwnProperty('company')
}

export function assertIsIOrderOverviewData(
  fn: string,
  val: any
): asserts val is IOrderOverview {
  if (!isIOrderOverviewData(val)) {
    throw new Error(`${fn} val should be an IOrderOverview, but it's not.`)
  }
}
